import React from 'react';
import {connect} from "react-redux";
import Translator from "../../helpers/Translator";
import DateTimeFormatter from "../../helpers/DateTimeFormatter";
import PriceFormatter from "../../helpers/PriceFormatter";
import {DOMAIN} from "../PricesCalendarContainer";
import Matrix from "./Matrix";
import IframeHelper from "../../helpers/IframeHelper";

class OneWayMatrix extends Matrix {
    assembleDates(dates) {
        let formattedDates = {};
        const today = DateTimeFormatter.createDate(DateTimeFormatter.getCurrentDate());
        Object.keys(dates).filter(function (date) {
            return today <= DateTimeFormatter.createDate(date);
        }).map((date) => {
            const dateObject = DateTimeFormatter.createDate(date);

            let price = dates[date];
            if (date === this.props.parameters['search-params'].departureDate
                && this.props.selectedMatrix === this.props.parameters['search-params'].departureCity
                && this.props.cheapest && this.props.cheapest.length > 0
            ) {
                price = this.props.cheapest[0].general.averageFlightPricePerPerson;
                if (this.props.cheapest[0].general.amountDisplay === 'overcharged') {
                    price += this.props.cheapest[0].general.serviceFeePerPerson
                }
            }

            formattedDates[date] = {
                key: date,
                date: DateTimeFormatter.getShortDate(dateObject, this.props.parameters['date-format']),
                weekday: this.translator.trans(DateTimeFormatter.getWeekday(dateObject.getDay())),
                price: price
            };

            return true;
        });

        return formattedDates;
    }

    renderDate(date) {
        return (
            <div key={date.date} className="col date header">{date.date} {date.weekday}.</div>
        );
    }

    renderDateList(dates) {
        let renderDates = [];
        Object.keys(dates).map((date) => renderDates.push(this.renderDate(dates[date])));

        return (
            <div className="row">
                <div className="col title">{this.translator.trans('Departure')}</div>
                {renderDates}
            </div>
        );
    }

    getPriceUrl(date, full) {
        const url = full ? this.props.parameters['current-url'] : this.props.parameters['url'];
        let urlParts = url.split('/');

        for (let i = 0; i < urlParts.length; i++) {
            let parts = urlParts[i].split(':');
            if (parts[0] === 'wfilter') {
                delete urlParts[i];
                continue;
            }

            if (parts[0] === 'departureDate' || parts[0] === 'departure_date') {
                parts[1] = date.key;
                parts = parts.join(':');
                urlParts[i] = parts;
            }

            if (parts[0] === 'departureCity' || parts[0] === 'departure_city') {
                parts[1] = this.props.selectedDepartureCity;
                parts = parts.join(':');
                urlParts[i] = parts;
            }
        }

        return urlParts.join('/');
    }

    renderPrice(active, date) {
        if (!date.price) {
            return (
                <div key={date.date} className={`col date ${active ? 'active' : ''}`}>
                    <a target="_parent" href={IframeHelper.link(this.props.parameters, this.getPriceUrl(date))}><span className="icon-search"></span></a>
                </div>
            );
        }

        return (
            <div key={date.date} className={`col date ${active ? 'active' : ''}`}>
                <a target="_parent" href={IframeHelper.link(this.props.parameters, this.getPriceUrl(date))}><span {...this.priceFormatter.format(date.price)}></span></a>
            </div>
        );
    }

    renderPriceList(dates) {
        let prices = [];
        let i = 0;
        Object.keys(dates).map((date) => {
            prices.push(this.renderPrice(this.props.parameters['search-params'].departureDate === date, dates[date]));
            i++;

            return true;
        });

        return (
            <div className="row">
                <div className="col title">{this.translator.trans('Price')}</div>
                {prices}
            </div>
        );
    }

    render() {
        if (!this.props.matrix) {
            return null;
        }

        this.translator = new Translator(this.props.translator, DOMAIN);
        this.priceFormatter = new PriceFormatter(this.props.parameters['price-format']);

        const dates = this.assembleDates(this.props.matrix);

        return (
            <div className={this.props.isMatrixCollapsed ? 'd-none' : ''}>
                {this.renderDateList(dates)}
                {this.renderPriceList(dates)}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        translator: state.TranslationsReducer.translations,
        parameters: state.ParametersReducer.parameters,
        matrix: ownProps.matrix,
        cheapest: state.FlightsReducer.cheapest,
        selectedDepartureCity: state.MatrixReducer.selectedDepartureCity,
        selectedMatrix: state.MatrixReducer.selectedDepartureCity,
        isMatrixCollapsed: state.MatrixReducer.isMatrixCollapsed,
    }
}

export default connect(mapStateToProps)(OneWayMatrix);



// WEBPACK FOOTER //
// ./src/components/pricesCalendar/OneWayMatrix.js